import { M100RichTextModule } from '~/lib/data-contract';
import { Container } from '../container/container.component';
import { useMemo } from 'react';
import styles from './m100-rich-text.module.css';
import clsx from 'clsx';
import { RawHtml, Typography } from '~/shared/components';

export type M100RichTextProps = M100RichTextModule;

const M100RichText = ({
    text,
    headline,
    secondaryColumn,
    centered,
    ...rest
}: M100RichTextProps) => {
    const columnCount = useMemo(() => [text, secondaryColumn].filter(Boolean).length, [
        text,
        secondaryColumn,
    ]);

    return (
        <Container
            hasGutter
            {...rest}
            spacingTop='default'
            spacingBottom='default'
            className={clsx(styles.root, styles[`columns-${columnCount}`], {
                [styles.centered]: centered,
            })}
        >
            <div className={styles.content}>
                <Typography variant="display2" as="h2" children={headline} />
                {(text || secondaryColumn) && (
                    <div className={clsx(styles.columns, styles[`columns-${columnCount}`])}>
                        {text && <RawHtml html={text} {...rest} />}
                        {secondaryColumn && <RawHtml html={secondaryColumn} {...rest} />}
                    </div>
                )}
            </div>
        </Container>
    );
};

export default M100RichText;
